import type { ComponentType } from 'react';
import {
  ArrowUpRight,
  Ban,
  Coins,
  HelpCircle,
  Menu,
  Newspaper,
  Pencil,
  Plus,
  Settings,
  Users,
} from 'lucide-react';
import {
  RiAddLine,
  RiAliensFill,
  RiApps2Line,
  RiClapperboardLine,
  RiCpuLine,
  RiCursorLine,
  RiDeleteBinLine,
  RiDiscordFill,
  RiEditLine,
  RiEyeLine,
  RiFileTextLine,
  RiFlashlightLine,
  RiGiftLine,
  RiGithubFill,
  RiGoogleFill,
  RiHdLine,
  RiHeadphoneLine,
  RiImage2Line,
  RiImageEditLine,
  RiInstagramFill,
  RiLockPasswordLine,
  RiMagicLine,
  RiMusic2Line,
  RiPaletteLine,
  RiQuestionLine,
  RiRefreshLine,
  RiRocketLine,
  RiShareLine,
  RiSparklingLine,
  RiTwitterXFill,
  RiVideoLine,
} from 'react-icons/ri';

type AnyIcon = ComponentType<any>;

// NOTE:
// We intentionally avoid `lazy(() => import('react-icons/ri'))` and
// `lazy(() => import('lucide-react'))` because those patterns pull the whole icon
// library into a runtime chunk and are flagged by Lighthouse as large unused JS.
const RI_ICONS: Record<string, AnyIcon> = {
  RiAddLine,
  RiAliensFill,
  RiApps2Line,
  RiClapperboardLine,
  RiCpuLine,
  RiCursorLine,
  RiDeleteBinLine,
  RiDiscordFill,
  RiEditLine,
  RiEyeLine,
  RiFileTextLine,
  RiFlashlightLine,
  RiGiftLine,
  RiGithubFill,
  RiGoogleFill,
  RiHdLine,
  RiHeadphoneLine,
  RiImage2Line,
  RiImageEditLine,
  RiInstagramFill,
  RiLockPasswordLine,
  RiMagicLine,
  RiMusic2Line,
  RiPaletteLine,
  RiQuestionLine,
  RiRefreshLine,
  RiRocketLine,
  RiShareLine,
  RiSparklingLine,
  RiTwitterXFill,
  RiVideoLine,
};

const LUCIDE_ICONS: Record<string, AnyIcon> = {
  ArrowUpRight,
  Ban,
  Coins,
  Menu,
  Newspaper,
  Pencil,
  Plus,
  Settings,
  Users,
  // fallback
  HelpCircle,
};

export function SmartIcon({
  name,
  size = 24,
  className,
  ...props
}: {
  name: string;
  size?: number;
  className?: string;
  [key: string]: any;
}) {
  const isRi = Boolean(name && name.startsWith('Ri'));
  const IconComponent =
    (isRi ? RI_ICONS[name] : LUCIDE_ICONS[name]) ??
    (isRi ? RI_ICONS.RiQuestionLine : LUCIDE_ICONS.HelpCircle);

  return <IconComponent size={size} className={className} {...props} />;
}
